// CON-8651. Two families of parameter, sent on every Algolia search request.
//
// `analyticsTags` are inert — Algolia records them against the search so the
// dashboard can slice by where the search came from, and nothing else.
// `ruleContexts` are *evaluated*: a Rule scoped to one of these names changes
// the results Algolia returns. Anything derived for a rule context therefore
// has to agree between the server render and the browser, or the same page
// gets two different result sets.

export const ALGOLIA_ANALYTICS_TAG = Object.freeze({
  HOMEPAGE: 'homepage',
  CATEGORY_PAGE: 'category_page',
  SEARCH_RESULTS_PAGE: 'search_results_page',
  PDP: 'pdp',
  SALE_PAGE: 'sale_page',
  CLEARANCE_PAGE: 'clearance_page',
  FLASH_SALE_PAGE: 'flash_sale_page',
});

export const ALGOLIA_RULE_CONTEXT = Object.freeze({
  STORE_SUBDOMAIN: 'store_subdomain',
  MAIN_SITE: 'main_site',
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
});

// The campaign landing pages that count as `sale_page`. These are ordinary CMS
// content routes carrying no marker of their own, so the path is the only
// signal — the list is spelled out in the ticket and has to be maintained by
// hand when a campaign is added.
export const SALE_PAGE_PATHS = Object.freeze([
  'presidents-day-sale',
  'memorial-day-sale',
  '4th-of-july-sale',
  'labor-day-sale',
  'black-friday-cyber-monday-deals',
]);
